import React from 'react';
import type { ReactNode } from 'react';
import { DrawerProvider } from '@balance-web/drawer';
import { ToastProvider } from '@balance-web/toast';
import { SideDrawerProvider } from '@balance-web/side-drawer';

export const PackageProviders = ({ children }: { children?: ReactNode }) => {
  return (
    <ToastProvider>
      <SideDrawerProvider>
        <DrawerProvider>{children}</DrawerProvider>
      </SideDrawerProvider>
    </ToastProvider>
  );
};
